// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vhjru{padding:8px 0px !important;max-height:424px;overflow-y:auto}.PZEdy{transition:transform .2s ease-in-out}.PZEdy.uqOZw{transform:rotate(-180deg)}.VedGQ{margin:8;margin-top:0}.maVpq{border-top-color:transparent !important;border:0 !important}.Hq7J4{border-radius:8px;border:1px solid transparent !important;background:linear-gradient(#F4F4F7, #F4F4F7) padding-box,linear-gradient(135deg, #2CF1FF 0%, #7856F9 50%, #FF5F8F 100%) border-box !important;padding:12px 16px}.Hq7J4:hover{background:linear-gradient(#eaeaef, #eaeaef) padding-box,linear-gradient(135deg, #2CF1FF 0%, #7856F9 50%, #FF5F8F 100%) border-box !important}.CfYsw{display:flex;flex-direction:column}.eZ9eQ{display:flex;flex-direction:column}._0gMml{display:flex;flex-direction:column;max-height:424px;overflow-y:auto;flex:0 1 auto}.hJxDa{flex-shrink:0;background:#fff;border-top:1px solid #eaeaef;display:flex;flex-direction:column;padding-bottom:max(0px, var(--capacitor-safe-area-bottom, 0px))}.zta1d{display:flex;padding:8px 16px}.r8tBA{display:flex;align-items:center;justify-content:space-between;gap:16px;padding:10px 16px 14px;border-top:1px solid #eaeaef}.HFs7l{flex:1;min-width:0;font-size:12px;line-height:16px;color:#696992;white-space:normal}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple100": `#dad0fe`,
	"purple300": `#c3b3fc`,
	"purple400": `#b4a1fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"chartBlue": `#6a9ff0`,
	"chartPeach": `#fbd499`,
	"chartCyan": `#a9e5f2`,
	"chartPink": `#fda5ef`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"menuList": `vhjru`,
	"arrowIcon": `PZEdy`,
	"open": `uqOZw`,
	"promotionalActionWrapper": `VedGQ`,
	"footerScrollBorder": `maVpq`,
	"promotionalActionButton": `Hq7J4`,
	"editContainer": `CfYsw`,
	"popoverEdit": `eZ9eQ`,
	"editScroll": `_0gMml`,
	"editFooter": `hJxDa`,
	"editFooterCreateRow": `zta1d`,
	"editFooterManageRow": `r8tBA`,
	"editFooterHint": `HFs7l`
};
export default ___CSS_LOADER_EXPORT___;
